module.exports = __webpack_public_path__ + "img/spring_04.274ececc.png";